<template>
  <div>
    <div class="row">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">IndexPage</el-breadcrumb-item>
        <el-breadcrumb-item>Item</el-breadcrumb-item>
        <el-breadcrumb-item>Relation</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="row filter">

      <div class="filter-item clear">
        <div class="item-head ">
          <span>Location:</span>
        </div>
        <div class="item-content">
          <el-input v-model="filter.locationName" placeholder=""></el-input>
        </div>
      </div>

      <div class="filter-item clear">
        <div class="item-head ">
          <span>Trade:</span>
        </div>
        <div class="item-content">
          <el-input v-model="filter.tradeName" placeholder=""></el-input>
        </div>
      </div>

      <div class="filter-item clear">
        <div class="item-head ">
          <span>Item:</span>
        </div>
        <div class="item-content">
          <el-input v-model="filter.itemName" placeholder=""></el-input>
        </div>
      </div>

      <div class="filter-item clear">
        <div class="item-head ">
          <span>Type:</span>
        </div>
        <div class="item-content">
          <el-input v-model="filter.typeName" placeholder=""></el-input>
        </div>
      </div>

      <div class="filter-item clear">
        <div class="item-head ">
          <span>Status:</span>
        </div>
        <div class="item-content" style="margin-top: 8px;">
          <el-radio-group v-model="filter.status">
            <el-radio label="">所有状态</el-radio>
            <el-radio label="1">已完成</el-radio>
            <el-radio label="2">未完成</el-radio>
          </el-radio-group>
        </div>
      </div>

    </div>

    <div class="row">
      <el-button type="primary" @click.native="process">Query</el-button>
      <el-button type="primary" @click.native="add">New</el-button>
      <el-button type="primary" @click.native="update">设置下级</el-button>
      <el-button type="primary" @click.native="del">删除</el-button>
    </div>

    <div class="row">
      <template>
        <el-table
          :data.sync="records"
          stripe
          border
          style="width: 100%"
          @selection-change="selectionChange"
          @sort-change="sortChange"
          ref="tab1"
        >
          <el-table-column
            type="selection"
            min-width="30px">
          </el-table-column>
          <el-table-column
            prop="id"
            label="ID"
            min-width="50px">
          </el-table-column>


          <el-table-column
            sortable="custom"
            prop="locationName"
            label="LocationName"
            min-width="100px">
          </el-table-column>


          <el-table-column
            sortable="custom"
            prop="tradeName"
            label="TradeName"
            min-width="100px">
          </el-table-column>


          <el-table-column
            sortable="custom"
            prop="itemName"
            label="ItemName"
            min-width="100px">
          </el-table-column>

          <el-table-column
            sortable="custom"
            prop="typeName"
            label="FLAT"
            min-width="100px">
          </el-table-column>

          <el-table-column
            sortable="custom"
            prop="createAt"
            label="CREATE"
            min-width="100px">
          </el-table-column>
        </el-table>
      </template>
    </div>

    <div class="row">
      <el-pagination
        @size-change="process"
        @current-change="process"
        :current-page.sync="page.currentPage"
        :page-sizes="[10, 50, 100, 1000]"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>


    <!-- new form-->
    <div class="row">
      <el-dialog :title="form.title" :visible.sync="form.dialogFormVisible">

        <div class="row">
          <template>
            <el-table
              :data.sync="form.records"
              stripe
              border
              style="width: 100%"
              @selection-change="formSelectionChange"
            >
              <el-table-column
                type="selection"
                min-width="30px">
              </el-table-column>

              <el-table-column
                :prop="form.idProp"
                :label="form.idLabel"
                min-width="100px">
              </el-table-column>

              <el-table-column
                :prop="form.nameProp"
                :label="form.nameLabel"
                min-width="100px">
              </el-table-column>

              <el-table-column
                prop="createAt"
                label="CREATE"
                min-width="100px">
              </el-table-column>
            </el-table>
          </template>
        </div>

        <div class="row">
          <el-pagination
            @size-change="processForm"
            @current-change="processForm"
            :current-page.sync="form.page.currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size.sync="form.page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="form.total">
          </el-pagination>
        </div>


        <div slot="footer" class="dialog-footer">
          <el-button @click="form.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </div>
      </el-dialog>
    </div>


  </div>
</template>

<script>
  export default {
    name: "Type",
    data: function () {
      return {
        boolTrue:true,
        filter: {
          status:"",
          orderField:""
        },
        records: [],
        total: 0,
        page: {
          pageSize: 10,
          currentPage: 1
        },
        sections: [],
        //===================
        form: {
          processUrl: '',
          title: '',
          idProp: '',
          idLabel: '',
          nameProp: '',
          nameLabel: '',
          type: 'selection',
          total: 0,
          records: [],
          page: {
            pageSize: 10,
            currentPage: 1,
          },
          dialogFormVisible: false,
          url: '',
          sections: []
        }
      };
    },
    created: function () {
      this.process();
    },
    methods: {
      process: function () {
        this.$http.post("/lRelation/list", {
          filter: this.filter,
          pageSize: this.page.pageSize,
          currentPage: this.page.currentPage
        }).then(response => {
          this.records = response.data.data.data;
          this.total = response.data.data.total;
        });
      },
      //处理表单数据
      processForm: function () {
        this.$http.post(this.form.processUrl, {
          currentPage: this.form.page.currentPage,
          pageSize: this.form.page.pageSize
        }).then(response => {
          if (response.data.code === "1") {
            this.form.records = response.data.data.data;
            this.form.total = response.data.data.total;
          }
        });
      },
      //选项更改时
      selectionChange: function (sections) {
        this.sections = sections;
      },
      formSelectionChange: function (sections) {
        this.form.sections = sections;
      },
      submit: function () {
        //新增记录
        if (this.sections.length === 0) {
          //没有选择数据
          if (this.form.sections.length === 0) {
            this.form.dialogFormVisible = false;
            return;
          }
          let locationIds = "";
          for (let index = 0; index < this.form.sections.length; index++) {
            locationIds += this.form.sections[index].locationId + ",";
          }
          this.$http.post(this.form.url, {
            locationIds: locationIds
          }).then(response => {
            if (response.data.code === "1") {
              this.form.dialogFormVisible = false;
              this.$message.success("操作成功");
              this.process();
            }
          });
        } else {
          //设置下一级
          if (this.form.sections.length === 0) {
            this.form.dialogFormVisible = false;
            return;
          }
          //下级的id
          let ids = "";
          console.log(this.form.sections[0].itemId || this.form.sections[0].tradeId || this.form.sections[0].typeId)
          for (let index = 0; index < this.form.sections.length; index++) {
            console.log(this.form.sections[index].tradeId);
            ids = ids + (this.form.sections[index].itemId || this.form.sections[index].tradeId || this.form.sections[index].typeId);
            ids = ids + ",";
          }
          //relation的id集合
          let relationId = "";
          for(let relation of this.sections)
            relationId += relation.id + ",";
          this.$http.post(this.form.url, {
            //relationId集合
            relationId: relationId,
            //下级的列表
            ids: ids
          }).then(response => {
            if (response.data.code === "1") {
              this.form.dialogFormVisible = false;
              this.$message.success("操作成功");
              this.process();
              return;
            }
          })
        }
      },
      del: function () {
        if (this.sections.length === 0) {
          this.$message.error("没有选择数据");
          return;
        }

        var ids = "";
        for (var index = 0; index < this.sections.length; index++) {
          ids += this.sections[index].id + ",";
        }

        this.$confirm('确定删除这些记录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post("/lRelation/delete", {
            ids: ids,
          }).then(response => {
            if (response.data.code === "1") {
              this.$message.success("删除成功");
              this.process();
            }
          })
        });

      },
      //新增
      add: function () {
        //清空数据选择
        this.$refs.tab1.clearSelection();
        this.form.title = "选择Location";
        this.form.processUrl = "/location/list";
        this.form.url = "/lRelation/add";
        this.form.idProp = "locationId";
        this.form.idLabel = "LocationId";
        this.form.nameProp = "locationName";
        this.form.nameLabel = "LocationName";
        this.processForm();
        this.form.dialogFormVisible = true;
      },
      //设置下级
      update: function () {
        if (this.sections.length == 0) {
          this.$message.error("未选择数据");
          return;
        }

        //var locationId = this.sections[0].locationId;
        let tradeId = this.sections[0].tradeId;
        let itemId = this.sections[0].itemId;
        let typeId = this.sections[0].typeId;
        if (tradeId && itemId && typeId) {
          this.$message.error("只能设置未完成的数据");
          return;
        }
        //判定状态
        if(!this.validateNextLevel(this.sections)){
          this.$message.error("层级结构不一致");
          return;
        }
        this.form.url = "/lRelation/update";
        if (!tradeId) {
          this.form.title = "选择Trade";
          this.form.processUrl = "/trade/list";
          this.form.idProp = "tradeId";
          this.form.idLabel = "TradeId";
          this.form.nameProp = "tradeName";
          this.form.nameLabel = "TradeName";
        } else if (!itemId) {
          this.form.title = "选择Item";
          this.form.processUrl = "/item/list";
          this.form.idProp = "itemId";
          this.form.idLabel = "ItemId";
          this.form.nameProp = "itemName";
          this.form.nameLabel = "ItemName";
        } else {
          this.form.title = "选择Type";
          this.form.processUrl = "/type/list";
          this.form.idProp = "typeId";
          this.form.idLabel = "TypeId";
          this.form.nameProp = "typeName";
          this.form.nameLabel = "TypeName";
        }
        this.processForm();
        this.form.dialogFormVisible = true;
      },
      //判定集合是否符合要求
      validateNextLevel(selections) {
        if (selections.length <= 1)
          return true;
        let validateFlag = 0;
        for(let selection of selections){
          if(!validateFlag){
            validateFlag = this.validateFlag(selection);
            continue;
          }
          //判定是否合理
          if(this.validateFlag(selection) !== validateFlag)
            return false;
        }
        return true;
      },
      //判定状态
      validateFlag(selection){
        let flag = 0;
        if(selection == null || typeof(selection) === "undefined")
          return flag;
        if(selection.locationId)
          flag |= 8;
        if(selection.tradeId)
          flag |= 4;
        if(selection.itemId)
          flag |= 2;
        if(selection.typeId)
          flag |= 1;
        return flag;
      },
      sortChange(column){
        if(column == null){
          this.filter.orderField = "";
          return ;
        }
        this.filter.orderField =  column.order.toLowerCase() === "ascending" ? column.prop + " asc" : column.prop + " desc";
        this.process();
      }
    }
  }
</script>

<style scoped>

  .filter {
    border: 1px solid #DCDFE6;
  }

  .filter > .filter-item {
    border-bottom: 1px dashed #DCDFE6;
    position: relative;
    display: block;
    padding: 5px 0 5px 0;
  }

  .filter > .filter-item:last-of-type {
    border-bottom: none;
  }

  .filter > .filter-item > .item-head {
    display: inline-block;
    width: 150px;
    float: left;
    line-height: 32px;
    padding-left: 10px;
  }

  .filter > .filter-item > .item-content {
    display: block;
    float: left;
    margin-left: 10px;
  }

  .clear {
    display: block;
    overflow: hidden;
  }


</style>



// WEBPACK FOOTER //
// src/components/item/LRelation.vue